import type { Right } from '@gozoki/tools'
import type { PermissionTuple } from '~/utils/ability'
import type { PermissionRequirement } from '~/utils/rbac'

/**
 * Source unique des droits du module 25 — Administration › Rôles.
 *
 * Consommée par les `staticData.permission` des routes et par les affordances des écrans : un seul
 * endroit à mettre à jour, pas de dérive possible entre un bouton et la page qu'il ouvre.
 */
export const ROLE_READ: PermissionTuple = ['read', 'roles-admin.roles.role']
export const ROLE_ADD: PermissionTuple = ['add', 'roles-admin.roles.role']
export const ROLE_EDIT: PermissionTuple = ['edit', 'roles-admin.roles.role']

/** Dialogue « Assigner des utilisateurs » (remplacement complet de la liste d'admins du rôle). */
export const ROLE_ADMINS_EDIT: PermissionTuple = ['edit', 'roles-admin.roles.admin-assignment']

/**
 * Créer un rôle, c'est aussi écrire sa matrice de permissions : le formulaire enchaîne
 * `POST /rbac/roles` puis `PUT /rbac/roles/:id/permissions(-v2)`, gardés respectivement par `add` et
 * `edit`. Les deux droits sont donc requis, plutôt que d'ouvrir la réécriture des permissions d'un
 * rôle existant à quiconque peut en créer un.
 */
export const ROLE_CREATE: PermissionRequirement = [ROLE_ADD, ROLE_EDIT]

/** Droit v1 exigé tant que le flag `permission-v2` est OFF (les tuples v2 y passent tous). */
export const ROLES_LEGACY_RIGHTS: Right[] = ['SUPER_ADMIN']
